import ProxyBase from '../../../../core/proxies/ProxyBase'

class PortfolioScoreProxy extends ProxyBase {
  getScoreRangesCreditRisk(params) {
    return this.get('Score/ScoreRangesCreditRisk', params)
  }
  getScoreRangesPerformance(params) {
    return this.get('Score/ScoreRangesPerformance', params)
  }
  //ScoreTrend
  getRiskTrend(params) {
    return this.post('PortfolioInsights/Score/RiskTrend', params)
  }
  getPerformanceTrend(params) {
    return this.post('PortfolioInsights/Score/PerformanceTrend', params)
  }
  getTrendConfig(params) {
    return this.get('PortfolioInsights/Score/TrendConfig', params)
  }
  postTrendConfig(params) {
    return this.post('PortfolioInsights/Score/TrendConfig', params)
  }
  //distribution
  getDistributionCreditRisk(params) {
    return this.post('PortfolioInsights/Score/DistributionCreditRisk', params)
  }
  getDistributionPerformance(params) {
    return this.post('PortfolioInsights/Score/DistributionPerformance', params)
  }
  //top 10 companies
  getHighestCreditRisk(params) {
    return this.post('PortfolioInsights/Score/HighestCreditRisk', params)
  }
  getHighestPerformance(params) {
    return this.post('PortfolioInsights/Score/HighestPerformance', params)
  }
  getBiggestCreditRisk(params) {
    return this.post(
      'PortfolioInsights/Score/BiggestCreditRiskScoreChange',
      params,
    )
  }
  getBiggestPerformance(params) {
    return this.post(
      'PortfolioInsights/Score/BiggestPerformanceScoreChange',
      params,
    )
  }
  getLargestDeclineCreditRisk(params) {
    return this.post(
      'PortfolioInsights/Score/LargestDeclineCreditRiskScore',
      params,
    )
  }
  getLargestDeclinePerformance(params) {
    return this.post(
      'PortfolioInsights/Score/LargestDeclinePerformanceScore',
      params,
    )
  }
  //trend by port
  getTrendByPortfolioCreditRisk(params) {
    return this.post(
      'PortfolioInsights/Score/TrendByPortfolioCreditRiskScore',
      params,
    )
  }
  getTrendByPortfolioPerformanceScore(params) {
    return this.post(
      'PortfolioInsights/Score/TrendByPortfolioPerformanceScore',
      params,
    )
  }
  //export
  exportDistributionCreditRisk(params) {
    return this.post(
      'PortfolioInsights/Score/DistributionCreditRisk/Export',
      params,
      {},
      'download',
    )
  }
  exportDistributionPerformance(params) {
    return this.post(
      'PortfolioInsights/Score/DistributionPerformance/Export',
      params,
      {},
      'download',
    )
  }
  exportTopCreditRiskScore(params) {
    return this.post(
      'PortfolioInsights/Score/TopCreditRiskScore/Export',
      params,
      {},
      'download',
    )
  }
  exportTopPerformanceScore(params) {
    return this.post(
      'PortfolioInsights/Score/TopPerformanceScore/Export',
      params,
      {},
      'download',
    )
  }
  exportTrendByPortfolioCreditRiskScore(params) {
    return this.post(
      'PortfolioInsights/Score/TrendByPortfolioCreditRiskScore/Export',
      params,
      {},
      'download',
    )
  }
  exportTrendByPortfolioPerformanceScore(params) {
    return this.post(
      'PortfolioInsights/Score/TrendByPortfolioPerformanceScore/Export',
      params,
      {},
      'download',
    )
  }
}

export default new PortfolioScoreProxy()
